import ServiceTags from ".";

export const serviceTagsRoutes = () => [
  {
    path: "/admin/services-tags",
    title: "Service Management",
    layout: "admin",
    routeType: "admin",
    component: ServiceTags,
  },
];
